export const like = async ({ session, body }) => {
  const { user_id } = session;
  const { active, base_product_id } = body;
  if (user_id && base_product_id) {
    if (active) {
      const bp_likes = await QUERY1`INSERT INTO base_products_likes ${VALUES({
        user_id,
        base_product_id,
      })}
      ON CONFLICT DO NOTHING
      RETURNING *`;
      if (bp_likes) {
        await QUERY1`UPDATE base_products SET like_count=like_count+1 WHERE id=${base_product_id}`;
      }
    } else {
      const bp_likes = await QUERY1`DELETE FROM base_products_likes WHERE ${EQ({
        user_id,
        base_product_id,
      })}
      RETURNING *`;
      if (bp_likes) {
        await QUERY1`UPDATE base_products SET like_count=like_count-1 WHERE id=${base_product_id}`;
      }
    }
  }
};
